<template>
  <div class="container">
    <h2>体积单位换算</h2>
    <div class="converter">
      <el-form :model="form" label-width="120px">
        <el-form-item label="输入数值">
          <el-input-number
            v-model="form.value"
            :precision="6"
            :step="0.1"
            @change="convert"
          />
        </el-form-item>
        <el-form-item label="从">
          <el-select v-model="form.from" @change="convert">
            <el-option
              v-for="unit in units"
              :key="unit.value"
              :label="unit.label"
              :value="unit.value"
            />
          </el-select>
        </el-form-item>
      </el-form>

      <div class="results">
        <el-card v-for="unit in units" :key="unit.value" class="result-card">
          <template #header>
            <div class="card-header">
              <span>{{ unit.label }}</span>
              <el-button
                type="text"
                @click="copyValue(results[unit.value])"
              >复制</el-button>
            </div>
          </template>
          <div class="result-value">{{ formatNumber(results[unit.value]) }}</div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive } from 'vue'
import { ElMessage } from 'element-plus'

const units = [
  { label: '立方米 (m³)', value: 'm3' },
  { label: '立方分米 (dm³)', value: 'dm3' },
  { label: '立方厘米 (cm³)', value: 'cm3' },
  { label: '立方毫米 (mm³)', value: 'mm3' },
  { label: '升 (L)', value: 'l' },
  { label: '毫升 (mL)', value: 'ml' },
  { label: '加仑 (gal)', value: 'gal' },
  { label: '夸脱 (qt)', value: 'qt' },
  { label: '品脱 (pt)', value: 'pt' },
  { label: '盎司 (fl oz)', value: 'floz' }
]

const form = reactive({
  value: 1,
  from: 'm3'
})

const results = ref({})

// 转换系数（相对于立方米）
const ratios = {
  'm3': 1,
  'dm3': 1000,
  'cm3': 1000000,
  'mm3': 1000000000,
  'l': 1000,
  'ml': 1000000,
  'gal': 264.172,
  'qt': 1056.69,
  'pt': 2113.38,
  'floz': 33814.0
}

const convert = () => {
  // 先转换为立方米
  const m3Value = form.value / ratios[form.from]

  // 转换为其他单位
  Object.keys(ratios).forEach(unit => {
    results.value[unit] = m3Value * ratios[unit]
  })
}

const formatNumber = (num) => {
  if (num === undefined) return ''
  if (Math.abs(num) < 0.000001 || Math.abs(num) > 999999999) {
    return num.toExponential(6)
  }
  return num.toFixed(6).replace(/\.?0+$/, '')
}

const copyValue = async (value) => {
  try {
    await navigator.clipboard.writeText(value.toString())
    ElMessage.success('复制成功')
  } catch (err) {
    ElMessage.error('复制失败')
  }
}

// 初始转换
convert()
</script>

<style scoped>
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  margin-top: 80px;
}

.results {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 20px;
  margin-top: 20px;
}

.result-card {
  margin-bottom: 10px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.result-value {
  font-family: monospace;
  font-size: 1.1em;
  text-align: center;
  word-break: break-all;
}
</style>
